<template>
  <div>
    <el-form v-show="isEdit" ref="info" :model="info" class="global-form2" label-width="110px" :rules="rules">
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="info.projectName" size='small' placeholder="请输入项目名称" clearable maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="项目状态" prop='projectState'>
        <el-select v-model="info.projectState" placeholder="请选择项目状态">
          <el-option label="未开工" value="1">
          </el-option>
          <el-option label="在建" value="2">
          </el-option>
          <el-option label="已移交" value="3">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目区域" prop="projectArea">
        <el-cascader v-model="addr" :options="addrList"
          :props="{ value: 'label', children: 'children', label: 'label' }" @change="areaChange" placeholder="请选择省市区"
          clearable></el-cascader>
      </el-form-item>
      <el-form-item prop="projectAddr">
        <el-autocomplete v-model="info.projectAddr" :disabled="info.projectArea === ''" :fetch-suggestions="addrFetch"
          :maxlength='50' autocomplete="new-password" placeholder="请输入详细地址" @select="addrChange">
          <template v-slot="{ item }">
            <span>{{ item.name }}</span>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="养护开始时间" prop='maintStartTime'>
        <el-date-picker v-model="info.maintStartTime" type="date" placeholder="请选择时间" value-format="timestamp"
          :picker-options="startPickerOptions" :editable='false'>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="养护结束时间" prop='maintEndTime'>
        <el-date-picker v-model="info.maintEndTime" type="date" placeholder="请选择时间" value-format="timestamp"
          :picker-options="endPickerOptions" :editable='false'>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="养护面积" prop='maintAcreage'>
        <el-input class="widthlimit" v-model="info.maintAcreage" placeholder="请输入养护面积" maxlength='9'
          clearable></el-input>
        平方米
      </el-form-item>
      <el-form-item label="绿化面积" prop='greenAcreage'>
        <el-input class="widthlimit" v-model="info.greenAcreage" placeholder="请输入绿化面积" maxlength='9'
          clearable></el-input>
        平方米
      </el-form-item>
      <el-form-item label="水域面积" prop='watersAcreage'>
        <el-input class="widthlimit" v-model="info.watersAcreage" placeholder="请输入水域面积" maxlength='9'
          clearable></el-input>
        平方米
      </el-form-item>
      <el-form-item label="养护单位" prop='maintUnit'>
        <el-input v-model="info.maintUnit" placeholder="请输入养护单位" maxlength='50' clearable></el-input>
      </el-form-item>
      <el-form-item label="项目类型" prop='projectType'>
        <el-select v-model="info.projectType" placeholder="请选择项目类型" maxlength='50' clearable>
          <el-option v-for="(item, index) in projectTypeList" :label="item.dicValue" :value="item.dicCode" :key='index'>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="公司LOGO">
        <div v-if="info.buildLogoUrl" class="imgBlock">
          <el-image :src="info.buildLogoUrl" :preview-src-list="[info.buildLogoUrl]" fit="fill">
          </el-image>
          <span></span>
          <i class="el-icon-close" @click="imgRemove('1')"></i>
        </div>

        <UploadFile @onSuccess="onSuccess1" :slotShow='true' v-else>
          <template>
            <i class="el-icon-plus"></i>
            <p>上传照片</p>
          </template>
        </UploadFile>
      </el-form-item>

      <el-form-item label="客户公司LOGO">
        <div v-if="info.customerLogoUrl" class="imgBlock">
          <el-image :src="info.customerLogoUrl" :preview-src-list="[info.customerLogoUrl]" fit="fill">
          </el-image>
          <span></span>
          <i class="el-icon-close" @click="imgRemove('2')"></i>
        </div>
        <UploadFile @onSuccess="onSuccess2" :slotShow='true' v-else>
          <template>
            <i class="el-icon-plus"></i>
            <p>上传照片</p>
          </template>
        </UploadFile>
      </el-form-item>

      <el-form-item label="项目总览图片" v-if="info.projectType !== '4'">
        <div v-if="info.projectImgUrl" class="imgBlock">
          <el-image :src="info.projectImgUrl" :preview-src-list="[info.projectImgUrl]" fit="fill">
          </el-image>
          <span></span>
          <i class="el-icon-close" @click="imgRemove('3')"></i>
        </div>
        <UploadFile @onSuccess="onSuccess3" :slotShow='true' v-else>
          <template>
            <i class="el-icon-plus"></i>
            <p>上传照片</p>
          </template>
        </UploadFile>
      </el-form-item>

      <el-form-item label="公园图片" v-if="info.projectType === '4'">
        <div class="imgLists">
          <template v-if="info.parkImgList && info.parkImgList.length > 0">
            <div class="imgBlock" v-for="(item, index) in info.parkImgList" :key="index">
              <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]"
                fit="fill">
              </el-image>
              <span></span>
              <i class="el-icon-close" @click="imgRemove1(index)"></i>
            </div>
          </template>
          <UploadFile @onSuccess="onSuccess4" v-if="!info.parkImgList || info.parkImgList.length < 5" :slotShow="true">
            <template>
              <i class="el-icon-plus"></i>
              <p>上传照片</p>
            </template>
          </UploadFile>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleAdd" :disable="isAdding">保存</el-button>
      </el-form-item>
    </el-form>
    <el-form v-show="!isEdit" label-width="110px">
      <el-form-item label="项目名称">
        <p>{{ info.projectName }}</p>
      </el-form-item>
      <el-form-item label="项目状态">
        <p>{{ getState(info.projectState) }}</p>
      </el-form-item>
      <el-form-item label="项目区域">
        <p>{{ info.projectProvince }}{{ info.projectCity }}{{ info.projectArea }}{{ info.projectAddr || '' }}</p>
      </el-form-item>
      <el-form-item label="养护开始时间">
        <p>{{ info.maintStartTime || '' }}</p>
      </el-form-item>
      <el-form-item label="养护结束时间">
        <p>{{ info.maintEndTime || '' }}</p>
      </el-form-item>
      <el-form-item label="养护面积">
        <p>{{ info.maintAcreage ? info.maintAcreage + '平方米' : '' }}</p>
      </el-form-item>
      <el-form-item label="绿化面积">
        <p>{{ info.greenAcreage ? info.greenAcreage + '平方米' : '' }}</p>
      </el-form-item>
      <el-form-item label="水域面积">
        <p>{{ info.watersAcreage ? info.watersAcreage + '平方米' : '' }}</p>
      </el-form-item>
      <el-form-item label="养护单位">
        <p>{{ info.maintUnit || '' }}</p>
      </el-form-item>
      <el-form-item label="项目类型">
        <p>{{ info.projectTypeName || '' }}</p>
      </el-form-item>
      <el-form-item label="公司LOGO">
        <div class="imgList">
          <div v-if="info?.buildLogo?.fileId" class="ListBox">
            <div class="imgItem">
              <el-image :src="info.buildLogo.filePrefix + info.buildLogo.fileUrl"
                :preview-src-list="[info.buildLogo.filePrefix + info.buildLogo.fileUrl]" fit="fill">
              </el-image>
            </div>
          </div>
          <div v-else></div>
        </div>
      </el-form-item>
      <el-form-item label="客户公司LOGO">
        <div class="imgList">
          <div v-if="info?.customerLogo?.fileId" class="ListBox">
            <div class="imgItem">
              <el-image :src="info.customerLogo.filePrefix + info.customerLogo.fileUrl"
                :preview-src-list="[info.customerLogo.filePrefix + info.customerLogo.fileUrl]" fit="fill">
              </el-image>
            </div>
          </div>
          <div v-else></div>
        </div>
      </el-form-item>
      <el-form-item label="项目总览图片" v-if="info.projectType !== '4'">
        <div class="imgList">
          <div v-if="info?.projectImg?.fileId" class="ListBox">
            <div class="imgItem">
              <el-image :src="info.projectImg.filePrefix + info.projectImg.fileUrl"
                :preview-src-list="[info.projectImg.filePrefix + info.projectImg.fileUrl]" fit="fill">
              </el-image>
            </div>
          </div>
          <div v-else></div>
        </div>
      </el-form-item>
      <el-form-item label="公园图片" v-if="info.projectType === '4'">
        <div class="imgLists">
          <div v-if="info.parkImgList.length" class="ListBox">
            <div class="imgBlock" v-for="(item, index) in info.parkImgList" :key="index">
              <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]"
                fit="fill">
              </el-image>
            </div>
          </div>
          <div v-else></div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showEdit" v-if="$ButtonShow('YHP_EDT_01')">编辑</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { twoDecimal } from '@/utils/validate'
import UploadFile from '@/components/uploadFile/Index.vue'
export default {
  name: 'List',
  components: {
    UploadFile
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },
  data() {
    return {
      addrList: [],
      addr: [],
      info: {
        parkImgList: []
      },
      projectTypeList: [],
      startPickerOptions: {
        disabledDate: (time) => {
          if (this.info.maintEndTime && this.info.maintEndTime) {
            return time.getTime() > Number(this.info.maintEndTime)
          } else {
            return false
          }
        }
      },
      endPickerOptions: {
        disabledDate: (time) => {
          if (this.info.maintStartTime && this.info.maintStartTime) {
            return time.getTime() < Number(this.info.maintStartTime)
          } else {
            return false
          }
        }
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: ['blur', 'change'], whitespace: true }
        ],
        projectState: [
          { required: true, message: '请选择项目状态', trigger: 'change' }
        ],
        projectArea: [
          { required: true, message: '请选择省市区', trigger: 'change' }
        ],
        projectAddr: [
          { required: true, message: '请输入项目详细地址', trigger: ['blur', 'change'] }
        ],
        maintStartTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        maintEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        maintAcreage: [
          { validator: twoDecimal }
        ],
        greenAcreage: [
          { validator: twoDecimal }
        ],
        watersAcreage: [
          { validator: twoDecimal }
        ]
      },
      isAdding: false,
      isEdit: true
    }
  },
  computed: {
    projectId() {
      return this.$route.query.projectId || ''
    }
  },
  created() {
    // 新增
    this.getAddrList()
    !this.projectId && this.getProjectTypeList()
    if (this.projectId !== '') {
      this.isEdit = false
      this.getProjectDetail()
    }
  },
  methods: {
    // 获取项目信息
    getProjectDetail() {
      this.$axios.get(this.$apis.project.selectYhProjectByProjectId, { projectId: this.projectId }).then(res => {
        this.info = res || []
      })
    },
    // 获取地址信息
    getAddrList() {
      this.$axios.get(this.$apis.common.getRegion).then(res => {
        this.addrList = res || []
      })
    },
    // 获取项目类型
    getProjectTypeList(callback) {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'projectType' }).then(res => {
        console.log('项目类型', res);
        this.projectTypeList = res.projectType || []
        callback && callback()
      })
    },
    getState(state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    },
    areaChange() {
      if (this.addr.length === 3 && this.addr[2] !== '') {
        this.info.projectProvince = this.addr[0] || ''
        this.info.projectCity = this.addr[1] || ''
        this.info.projectArea = this.addr[2] || ''
      } else {
        this.info.projectProvince = ''
        this.info.projectCity = ''
        this.info.projectArea = ''
      }
    },
    // 详细地址输入
    addrFetch(queryString, cb) {
      AMap.plugin(['AMap.AutoComplete', 'AMap.Geocoder'], () => {
   
        // 根据所选区域初始化项目经纬度
        const geocoder = new AMap.Geocoder({
          city: this.info.projectCity
        })
        geocoder.getLocation(this.info.projectArea, (status, result) => {
          const res = result
          if (status === 'complete' && res.geocodes.length) {
            this.info.latitude = res.geocodes[0].location.getLat().toString()
            this.info.longitude = res.geocodes[0].location.getLng().toString()
          }
        })
        // 实例化Autocomplete
        const autoComplete = new AMap.AutoComplete({
          city: this.info.projectCity
        })
        autoComplete.search(this.info.projectArea + queryString, (status, result) => {
          const res = result
          if (status === 'complete') {
            cb(res.tips)
          }
        })
      })
    },
    // 点击详细地址下拉
    addrChange(data) {
      this.info.projectAddr = data.name
      this.info.latitude = data.location.getLat().toString()
      this.info.longitude = data.location.getLng().toString()
    },
    // 图片上传成功
    onSuccess1(file) {
      this.info.buildLogo = file
      this.info.buildLogoUrl = file.filePrefix + file.fileUrl
      this.$forceUpdate()
    },
    onSuccess2(file) {
      this.info.customerLogo = file
      this.info.customerLogoUrl = file.filePrefix + file.fileUrl
      this.$forceUpdate()
    },
    onSuccess3(file) {
      this.info.projectImg = file
      this.info.projectImgUrl = file.filePrefix + file.fileUrl
      this.$forceUpdate()
    },
    onSuccess4(file) {
      this.info.parkImgList.push(file)
      this.$forceUpdate()
    },
    // 照片删除
    imgRemove(str) {
      const arr = ['', 'buildLogo', 'customerLogo', 'projectImg']
      const arr1 = ['', 'buildLogoUrl', 'customerLogoUrl', 'projectImgUrl']
      const key = arr[Number(str)]
      const keys = arr1[Number(str)]
      this.info[key] = {
        fileName: '',
        filePrefix: '',
        fileUrl: ''
      }
      this.info[keys] = ''
      this.$forceUpdate()
    },
    imgRemove1(index) {
      this.info.parkImgList.splice(index, 1)
    },
    handleAdd() {
      this.$refs.info.validate(valid => {
        if (valid) {
          this.handleTime()
          delete this.info.projectTypeName
          delete this.info.buildLogoUrl
          delete this.info.customerLogoUrl
          delete this.info.projectImgUrl
          if (this.projectId !== '') {
            this.editProject()
          } else {
            this.addProject()
          }
        }
      })
    },
    addProject() {
      this.isAdding = true
      this.$axios.post(this.$apis.project.insertYhProject, this.info).then(() => {
        this.$message.success('添加成功')
        this.$router.back()
        this.$store.dispatch('getProjectList')
        // this.$store.dispatch('getNormalProjectList')
      }).catch(() => {
        this.handleTime(true)
        this.$store.dispatch('getProjectList')
        // this.$store.dispatch('getNormalProjectList')
      }).finally(() => {
        this.isAdding = false
      })
    },
    // 编辑项目信息
    showEdit() {
      // 查询项目类型字典
      this.getProjectTypeList(() => {
        this.isEdit = true
        this.handleTime(true)
        this.info.buildLogoUrl = this.info?.buildLogo ? `${this.info?.buildLogo?.filePrefix}${this.info?.buildLogo?.fileUrl}` : ''
        this.info.customerLogoUrl = this.info?.customerLogo ? `${this.info?.customerLogo?.filePrefix}${this.info?.customerLogo?.fileUrl}` : ''
        this.info.projectImgUrl = this.info?.projectImg ? `${this.info?.projectImg?.filePrefix}${this.info?.projectImg?.fileUrl}` : ''
        this.addr = [this.info.projectProvince, this.info.projectCity, this.info.projectArea]
      })
    },
    editProject() {
      this.isAdding = true
      this.$axios.post(this.$apis.project.updateYhProject, this.info).then(() => {
        this.$message.success('修改成功')
        this.isEdit = false
        this.getProjectDetail()
        this.$store.dispatch('getProjectList')
        // this.$store.dispatch('getNormalProjectList')
      }).catch(() => {
        this.handleTime(true)
        this.$store.dispatch('getProjectList')
        // this.$store.dispatch('getNormalProjectList')
      }).finally(() => {
        this.isAdding = false
      })
    },
    // 处理时间格式
    handleTime(type) {
      if (type) {
        this.info.maintStartTime = this.info.maintStartTime ? new Date(this.info.maintStartTime).getTime().toString() : null
        this.info.maintEndTime = this.info.maintEndTime ? new Date(this.info.maintEndTime).getTime().toString() : null
      } else {
        this.info.maintEndTime = this.$dayjs(Number(this.info.maintEndTime)).format('YYYY-MM-DD')
        this.info.maintStartTime = this.$dayjs(Number(this.info.maintStartTime)).format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.el-form {
  margin-top: 20px;

  .widthlimit {
    width: 320px;
  }
}

.imgLists {
  display: flex;
  flex-wrap: wrap;

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0;

    .el-image,
    img {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;
  }
}

.imgBlock {
  position: relative;
  height: 104px;
  width: 104px;
  margin-right: 10px;
  border-radius: 2px;

  .el-image,
  img {
    width: 100%;
    height: 100%;
  }

  span {
    position: absolute;
    top: 0;
    right: 0;
    width: 0px;
    height: 0px;
    border-top: 34px solid $color-default;
    border-left: 34px solid transparent;
  }

  i {
    transition: all 0.3s;
    position: absolute;
    top: 3px;
    right: 3px;
    font-size: 15px;
    color: #ffffff;
    cursor: pointer;
  }

  i:hover {
    color: #ffffff98;
  }
}

::v-deep .el-upload--picture-card {
  width: 104px;
  height: 104px;
  line-height: 26px;
  padding: 25px 10px;
}

.imgList {
  display: flex;
  margin-bottom: 20px;
  padding: 0 20px;

  span {
    display: inline-block;
    width: 85px;
    text-align: right;
    margin-right: 10px;
  }

  .ListBox {
    display: flex;
    flex-wrap: wrap;
    flex: 1;

    .imgItem {
      width: 120px;
      height: 120px;
      margin: 0 10px 10px 0;

      .el-image,
      img,
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
